import React from 'react';
import Container from 'react-bootstrap/Container';
import Badge from 'react-bootstrap/Badge';
import { HeartIcon, HeartFillIcon, ReceiptIcon } from './Icons';

function RecordPane(props) {
    const [getRefresh, setRefresh] = React.useState(0);

    const clickFav = (o) => {
        if (props.UpdateFavorite) {
            props.UpdateFavorite(props.RecIndex);
        }
        setRefresh(getRefresh + 1);
    }

    const IsFavorite = (n) => {
        return props.Favorite[n];
    }

    const clickShowActivity = (activityId) => {
        if (props.UpdateActivity) {
            props.UpdateActivity(activityId);
        }
    }

    let funcLevel = (l) => {
        switch (l) {
            case '1':
                return "danger";
            case '2':
                return "danger";
            case '3':
                return "secondary";
            case '4':
            default:
                return "secondary";
        }
    }

    let rec = props.Index.Records[props.RecIndex];
    let md = Number(rec.MDRESULT)
    let mdHex = (0x100000000 + ~(Math.abs(md))).toString(16)

    return (
        <Container fluid="xs" className="recordPane mb-3">
            <div>
                <small>
                    <span><Badge className="mr-1" pill={true} bg={funcLevel(rec.Level)}>{rec.Level}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="primary">{rec.Date}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="primary">{rec.Time}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="info">Pid:{rec.Pid}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="info">Tid:{rec.Tid}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="success">Stream:{rec.Stream}</Badge>&nbsp;</span>
                    <span><Badge className="mr-1" bg="success">ErrorType:{rec.ErrorType}</Badge>&nbsp;</span>
                    <Badge className="mr-1" bg="secondary">{rec.Function} {rec.File}:{rec.Line}</Badge>&nbsp;
                    {
                        md !== 0
                            ? <span><Badge className="mr-1" bg="warning">MDResult:{md >= 0 ? md : "0x" + mdHex}</Badge>&nbsp;</span>
                            : null
                    }
                    {
                        rec.ErrorCode > 0
                            ? <span><Badge className="mr-1" bg="warning">ErrorCode:{rec.ErrorCode}&nbsp;</Badge>&nbsp;</span>
                            : null
                    }
                    {
                        rec.ErrorCodeMsg.length > 0
                            ? <span><Badge className="mr-1" bg="warning">ErrorCodeMsg:{rec.ErrorCodeMsg}</Badge>&nbsp;</span>
                            : null
                    }
                    {
                        rec.Instance && Number(rec.Instance) > 0
                            ? <span><Badge className="mr-1" bg="secondary">Inst:{rec.Instance}</Badge>&nbsp;</span>
                            : null
                    }
                    {
                        props.UpdateActivity
                            ? <span className="mr-1" onClick={() => clickShowActivity(rec.ActivityId)}><ReceiptIcon />&nbsp;</span>
                            : null
                    }
                    {
                        IsFavorite(props.RecIndex)
                            ? <span className="mr-1" onClick={clickFav}><HeartFillIcon />&nbsp;</span>
                            : <span className="mr-1" onClick={clickFav}><HeartIcon />&nbsp;</span>
                    }
                </small>
            </div>
            <div className="my-wordwrap">{rec.Message}</div>
        </Container>);
}

export default RecordPane;
